import React from 'react';

const ReturnItemMessage = () => (
  <p className="u-fontsize-huge">Was the item for which the payment is being refunded returned by the client?</p>
);

export default ReturnItemMessage;
